export const fieldTranslations = {
  // Fields for transaction
  date: "Date de la transaction",
  c5_portfolio_name: "Compte",
  c5_static_datum_name: "Actif",
  market_value_ptf_ccy: "Montant en devise de reporting",
  market_value_local_ccy: "Montant en devise locale",
  quantity: "Quantité",
  transfer: "Type de transfert",
  category: "Type de mouvement",
  description: "Description du mouvement",

  // Fees fields
  fee_currency: "Devise du frais",
  broker_fee: "Frais de courtage",
  custodian_broker_fee: "Frais de courtage dépositaire",
  other_fee: "Autres frais",
  fees: "Total des frais",
  fee_type: "Type de frais",

  // Technical fields
  c5_portfolio_id: "ID du portefeuille",
  c5_static_datum_id: "ID de l'actif",
  c5_portfolio_account_type: "Type de compte",
  c5_static_datum_asset_class_1: "Classe d'actif principale",
  c5_static_datum_asset_class_2: "Sous-classe d'actif",
  c5_portfolio_currency: "Devise du portefeuille",
  c5_static_datum_currency: "Devise de l'actif",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
  time_serie_file_id: "ID du fichier de série temporelle",
};
